import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { SRText } from "../../component/ScreenReaderText/ScreenReaderText";
import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';


interface SolicitacaoProps {
  solicitacao: number
  resumo?: SolicitacaoResumida
}


export class SolicitacaoLink extends Component<SolicitacaoProps> {
  render() {
    return <Link to={{
      pathname: `/solicitacoes/${this.props.solicitacao}`,
      state: this.props.resumo
    }}>
      <SRText>id solicitação </SRText>#{this.props.solicitacao}
    </Link>
  }
}
